<template>
	<div>
		<div class="content-wrap">
			<div class="c3 title">
				<el-divider direction="vertical"></el-divider><span style="font-size: 18px;">{{title}}</span>
			</div>
			<!-- 搜索条件 -->
			<el-row class="search-wrap" :gutter="20">
				<el-col :sm="24" :md="8" class="u-m-t-44">
					<div class="u-flex u-row-between">
						<span class="c3 fw">年份：</span>
						<el-select multiple clearable size='mini' v-model="query.years" placeholder="请选择制定年份"
							class="u-flex-1" @change='yearSelectChange2' ref="select_year2">
							<el-option v-for="item in optionsYears" :key="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :sm="24" :md="8" class="u-m-t-44">
					<div class="u-flex u-row-between u-col-top">
						<span class="c3 fw" style="margin-top: 4px;">地区：</span>
						<el-cascader size='mini' v-model="query.province_codes" :options="area_list2" :props="props"
							clearable class="u-flex-1" :show-all-levels="false" collapse-tags>
						</el-cascader>
					</div>
				</el-col>
				<el-col :sm="24" :md="8" class="u-m-t-44">
					<div class="u-flex u-row-between">
						<span class="c3 fw">基本信息维度：</span>
						<el-select clearable multiple size='mini' v-model="query.index_2nd" placeholder="请选择"
							class="u-flex-1" @change='infoSelectChange2' ref="select_info2">
							<el-option v-for="item in optionsInfo2" :key="item.second_index_standard"
								:value="item.second_index_standard">
							</el-option>
						</el-select>
					</div>
				</el-col>
			</el-row>
			<!-- 操作按钮 -->
			<div class="u-flex u-row-right" style="margin-top: 24px;">
				<el-button size="mini" class="bg1" @click='search'>搜索</el-button>
				<el-button size="mini" class="bg2" v-if="$store.state.permission==2" @click='export_file'>导出所有</el-button>
				<download-excel :data="select_data" :fields="json_fields" :name="'千村统计'+moment(new Date()).format('YYYY-MM-DD')" class='el-button el-button--default el-button--mini bg3' type="primary" v-if="$store.state.permission==2"> 导出选中</download-excel>

			</div>
			<!-- 表格 -->
			<el-table :data="tableData" style="width: 100%;margin-top: 24px;" @selection-change='selectionChange'
				ref="table" row-key='RN'>
				<el-table-column type="selection" width="40" :reserve-selection='true'>
				</el-table-column>
				<el-table-column align='center' min-width='100' prop="YEAR" label="年份">
				</el-table-column>
				<el-table-column align='center' min-width='100' label="地区" prop="area_str">
					<!-- <template slot-scope="scope">
						<span>{{ scope.row.PROVINCE+scope.row.CITY+scope.row.COUNTY }}</span>
					</template> -->
				</el-table-column>
				<el-table-column align='center' min-width='100' prop="VILLAGE_NAME" label="详细地址">
				</el-table-column>
				<el-table-column align='center' min-width='100' prop="SECOND_INDEX_STANDARD" label="基本信息维度">
				</el-table-column>
				<el-table-column align='center' min-width='100' label="问题内容" prop="qusetion_str">
					<!-- <template slot-scope="scope">
						<span>{{ scope.row.STANDARD_QUESTION?scope.row.STANDARD_QUESTION:scope.row.QUESTION }}</span>
					</template> -->
				</el-table-column>
				<el-table-column align='center' min-width='100' prop="ANSWER" label="问题答案">
				</el-table-column>
			</el-table>
			<div class="u-flex u-row-center">
				<el-pagination class="u-m-t-30" small background layout="prev, pager, next" :total="total"
					:page-size='params.pageSize' :current-page='params.pageNum' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Report',
		components: {},
		data() {
			return {
				province_code: {}, // 所有省对应的code对象
				optionsYears: [], //年份下拉数据
				optionsYears_origin: [], //年份下拉数据源数据 不拼接全部
				area_list2: [],
				optionsInfo2: [],
				optionsInfo_origin: [],
				props: {
					multiple: true
				},
				title: '',
				query: {
					years: [],
					province_codes: [],
					index_2nd: [],
				},
				// tableData: [{
				// 		test1: '2017',
				// 		test2: '吉林省松原市乾安县',
				// 		test3: '让字乡大遐村',
				// 		test4: '本地产品与专业',
				// 		test5: '本地主要产业有哪些（可选1-3个选项）：工业中间产品加工产业',
				// 		test6: '1200',
				// 		id: 1
				// 	},
				// 	{
				// 		test1: '2017',
				// 		test2: '吉林省松原市乾安县',
				// 		test3: '让字乡大遐村',
				// 		test4: '本地产品与专业',
				// 		test5: '本地主要产业有哪些（可选1-3个选项）：工业中间产品加工产业',
				// 		test6: '1200',
				// 		id: 2
				// 	},
				// ]
				tableData: [],
				params: {
					pageSize: 10,
					pageNum: 1,
					year_list: undefined,
					second_index_list: undefined,
					province_code_list: undefined,
				},
				total: 0,
				select_data: [],
				//导出Excel表格的表头设置 
				json_fields: {
					'年份': 'YEAR',
					'地区': 'area_str',
					'详细地址': 'VILLAGE_NAME',
					'基本信息维度': 'SECOND_INDEX_STANDARD',
					'问题内容': 'qusetion_str',
					'问题答案': 'ANSWER',
				}
			}
		},
		async mounted() {
			this.$store.state.permission=sessionStorage.getItem("permission")
			this.title = localStorage.getItem('title')
			this.get_table_data()
			// 查询年列表下拉数据
			const res = await this.$API.queryIndex({
				query_type: "year"
			})
			this.optionsYears_origin = res.years
			this.optionsYears = ['全部年份', ...res.years.sort()]
			// 获取所有省对应的code
			const province_code = await this.$API.area_code()
			this.province_code = province_code.data
			let year_list = this.optionsYears_origin.join(';')
			// 查询地区维度下拉数据
			this.$API.area_group(year_list).then(res2 => {
				res2.forEach(item => {
					let children = []
					let arr = item.province_codes.split(';')
					arr.forEach(item => {
						children.push({
							value: item,
							label: this.province_code[item],
						})
					})
					this.area_list2.push({
						value: item.id,
						label: item.group_name,
						children
					})
				})
			})
			// 查询基本信息维度下拉数据
			this.$API.queryIndex({
				query_type: "index_2nd",
				year_list
			}).then(res3 => {
				// 判断有无数据  有数据在插全部 没数据返回个 {}
				if (res3.data) {
					this.optionsInfo2 = [{
						second_index_standard: '全部维度'
					}, ...res3.data]
				} else {
					this.optionsInfo2 = res3.data
				}
				this.optionsInfo_origin2 = res3.data
			})

		},
		methods: {
			async get_table_data() {


				const res = await this.$API.report_detail(this.params, this.$route.query.id)
				res.data.results.forEach(item=>{
					item.area_str=item.PROVINCE+item.CITY+item.COUNTY 
					item.qusetion_str=item.STANDARD_QUESTION?item.STANDARD_QUESTION:item.QUESTION
					
				})
				this.tableData = res.data.results
				this.total = res.data.count
			},
			selectionChange(selection) {
				// selection相当于scoped.row 数组形式 每行的数据
				// console.log(selection);
				this.select_data = selection
			},
			search() {
				// 处理数据
				let years = ''
				if (this.query.years.length) {
					if (this.query.years.includes("全部年份")) {
						years = undefined
					} else {
						years = this.query.years.join(';')
					}
				} else {
					years = undefined
				}
				let index_2nd = ''
				if (this.query.index_2nd.length) {
					if (this.query.index_2nd.includes("全部维度")) {
						index_2nd = undefined
					} else {
						index_2nd = this.query.index_2nd.join(';')
					}
				} else {
					index_2nd = undefined
				}
				let province_codes = ''
				if (this.query.province_codes.length) {
					this.query.province_codes.forEach((item, i) => {
						if (i == this.query.province_codes.length - 1) {
							province_codes += item[1]
						} else {
							province_codes += item[1] + ';'
						}
					})
				} else {
					province_codes = undefined
				}

				this.params.pageNum = 1
				this.params.year_list = years
				this.params.second_index_list = index_2nd
				this.params.province_code_list = province_codes
				this.get_table_data()
				// 用于多选表格，清空用户的选择
				this.$refs.table.clearSelection()
			},
			async export_file() {
				let params = {
					year_list: this.params.year_list,
					second_index_list: this.params.second_index_list,
					province_code_list: this.params.province_code_list,
					export: true
				}
				const res = await this.$API.report_detail(params, this.$route.query.id)
				window.open(location.origin + res.data.file_url);
				// window.open("http://10.2.36.97" + res.data.file_url);  
			},
			yearSelectChange2(val) {
				if (val.includes("全部年份")) {
					this.$refs.select_year2.blur()
					this.query.years = ["全部年份"]
				}
			},
			infoSelectChange2(val) {
				if (val.includes("全部维度")) {
					this.$refs.select_info2.blur()
					this.query.index_2nd = ["全部维度"]
				}
			},
			// 页数改变
			currentChange(current) {
				this.params.pageNum = current
				this.get_table_data()
			},
		},

	}
</script>

<style lang="less" scoped>
	.content-wrap {
		width: 100%;
		margin: 0 auto;
		max-width: 1000PX;
		padding: 0 12PX 20PX;
		box-sizing: border-box;

		.el-divider--vertical {
			height: 20PX;
			width: 4PX;
			transform: translateY(-2PX);
		}

		.el-divider {
			background-color: #7c2326;
		}

		.title {
			font-weight: 700;
			font-size: 18PX;
			margin-top: 30px;
		}

		.search-wrap {
			span {
				// width: 100PX;
				font-size: 14PX;
			}

			.el-select,
			.el-cascader {
				flex: 1;
				width: 100%;
				max-width: 252PX;
			}

			/deep/ .el-select__tags-text {
				font-size: 12PX;
			}
		}

		.el-button {
			// width: 80px;
			// min-width: 60PX;
			color: #fff;
			// font-size: 8PX !important;
		}

		.bg1 {
			background-color: #b81c22;
		}

		.bg2 {
			background-color: #f6ad3c;
		}
.bg3 {
			background-color: #409eff;
		}
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #7c2326;
			color: #FFF;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
			color: #fff;
		}

		/deep/ .el-pagination.is-background .el-pager li {

			background-color: rgba(124, 35, 38, .1);
		}

	}
</style>
